import Flickity from 'Flickity'

function DOMready(callback) {
  if (document.readyState != 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

DOMready(function () {
  const selectors = {
    dataGalleryMainProduct: 'main-product',
    dataGalleryThumbnailProduct: 'thumbnail-product',
  }

  //Product images slider
  const mainProductGallery = document.querySelectorAll(
    'div[data-gallery=' + selectors.dataGalleryMainProduct + ']'
  )
  const thumbnailProductGallery = document.querySelectorAll(
    'div[data-gallery=' + selectors.dataGalleryThumbnailProduct + ']'
  )

  const optionsFlktyMain = {
    // asNavFor: thumbnailProductGallery[0],
    cellAlign: 'left',
    prevNextButtons: true,
    wrapAround: true,
    contain: true,
    pageDots: true,
    adaptiveHeight: true,
    setGallerySize: false,
    // percentPosition: false
  }
  const optionsFlktyThumbnail = {
    asNavFor: mainProductGallery[0],
    cellAlign: 'left',
    prevNextButtons: false,
    wrapAround: true,
    contain: true,
    pageDots: false,
    adaptiveHeight: true,
    setGallerySize: false,
    // percentPosition: false
  }

  if (mainProductGallery.length > 0) {
    const flktyMain = new Flickity(mainProductGallery[0], optionsFlktyMain)
    const widthThumbnailProductGallery = parseFloat(
      window
        .getComputedStyle(thumbnailProductGallery[0], null)
        .height.replace('px', '')
    )
    const thumbnailsArr = document.querySelectorAll(
      'div[data-gallery=' + selectors.dataGalleryThumbnailProduct + '] > figure'
    )
    const widthThumbnailCell = parseFloat(
      window.getComputedStyle(thumbnailsArr[0], null).height.replace('px', '')
    )

    flktyMain.on('select', function (index) {
      const badge = document.querySelector('.product-badge')
      if (badge !== null) {
        index !== 0
          ? badge.classList.add('js-hide')
          : badge.classList.remove('js-hide')
      }

      thumbnailsArr.forEach((thumbnail) => {
        thumbnail.classList.remove('is-nav-selected')
      })
      thumbnailsArr[index].classList.add('is-nav-selected')

      if (window.matchMedia('screen and (min-width: 990px)').matches) {
        const scrollY = thumbnailsArr[index].offsetTop
        scrollToTop(thumbnailProductGallery[0], scrollY)
      } else {
        const scrollX = thumbnailsArr[index].offsetLeft
        translateX(thumbnailProductGallery[0], scrollX)
      }
    })

    thumbnailsArr.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', (_e) => {
        flktyMain.select(index)
      })
    })
    flktyMain.resize()

    function scrollToTop(element, num) {
      element.scrollTo({ top: num, behavior: 'smooth' })
    }

    function translateX(element, num) {
      element.scrollLeft = num
    }
  }

  const descriptionShow = document.querySelector('.product__description-show')
  const benefitsShow = document.querySelector('.product__benefits-show')

  if (descriptionShow != null && descriptionShow != undefined) {
    descriptionShow.addEventListener('click', () => {
      descriptionShow.classList.toggle('js-active')

      const descriptionContent = document.querySelector('.product__description')
      descriptionContent.style.display = ''
      descriptionContent.classList.toggle('js-active')
    })
  }

  if (benefitsShow != null && benefitsShow != undefined) {
    benefitsShow.addEventListener('click', () => {
      benefitsShow.classList.toggle('js-active')

      const benefitsContent = document.querySelector('.product__benefits')
      benefitsContent.style.display = ''
      benefitsContent.classList.toggle('js-active')
    })
  }

  const toggleBtnDescription = document.querySelector(
    '.product__description-toggle-btn'
  )
  const textDescription = document.querySelector(
    '.product__description-text--overflow'
  )

  if (toggleBtnDescription != null) {
    toggleBtnDescription.onclick = function () {
      textDescription.classList.toggle('show')
      if (textDescription.classList.contains('show')) {
        toggleBtnDescription.textContent = 'Read Less'
      } else {
        toggleBtnDescription.textContent = 'Read More'
      }
    }
  }

  //* Size Accordion
  const optionMain = document.querySelectorAll('.product__option-main')

  if (optionMain.length > 0) {
    optionMain.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        tab.parentElement.classList.toggle('js-active')

        const showOptionsInners = document.querySelectorAll(
          '.product__option-more'
        )
        if (showOptionsInners.length > 0) {
          showOptionsInners.forEach((activeOptionsInners) => {
            if (
              activeOptionsInners.parentElement.classList.contains('js-active')
            ) {
              activeOptionsInners.style.maxHeight =
                activeOptionsInners.scrollHeight + 'px'
            } else {
              activeOptionsInners.style.maxHeight = null
            }
          })
        }
      })
    })
  }

  //* Accordion
  {
    const acc = document.getElementsByClassName('js-accordion')
    const panel = document.getElementsByClassName('js-accordion-body')

    for (let i = 0; i < acc.length; i++) {
      acc[i].onclick = function () {
        this.classList.toggle('js-active')
        if (this.nextElementSibling.style.maxHeight) {
          this.nextElementSibling.style.maxHeight = null
        } else {
          this.nextElementSibling.style.maxHeight =
            this.nextElementSibling.scrollHeight + 'px'
        }
      }
    }
  }

  class StickyMenuProduct extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.stickyMenu = document.querySelector('.p-sticky-menu')
      this.announcementBar = document.querySelector('.announcement-bar')
      this.sectionHeader = document.querySelector('.section-header')
      this.productFormButtons = document.querySelector('.product-form__buttons')
      this.footer = document.querySelector('.footer')

      this.preventReveal = false

      this.onScrollHandler = this.onScroll.bind(this)
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
      window.addEventListener('scroll', this.onScrollHandler, false)

      this.createObserver()
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect
        observer.disconnect()
      })

      observer.observe(this.stickyMenu)
    }

    onScroll() {
      if (
        this.productFormButtons === undefined ||
        this.productFormButtons === null
      )
        return

      this.currentScrollTop =
        this.announcementBar.offsetHeight +
        this.sectionHeader.offsetHeight +
        this.productFormButtons.offsetTop

      this.currentScrollTopFooter =
        this.footer.offsetTop - this.footer.offsetHeight

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      if (scrollTop > this.currentScrollTop) {
        this.stickyMenu.classList.add('active')

        scrollTop > this.currentScrollTopFooter
          ? this.stickyMenu.classList.remove('active')
          : this.stickyMenu.classList.add('active')
      } else {
        this.stickyMenu.classList.remove('active')
      }
    }
  }

  customElements.define('p-sticky-menu', StickyMenuProduct)

  class CustomSelect extends HTMLElement {
    constructor() {
      super()

      this.input = this.querySelector('input')
      this.listOfOptions = this.querySelectorAll('.custom-select__option')
      this.productPrice = this.querySelector('.custom-select__product-price')
      this.product = JSON.parse(
        document.querySelector('.product-json').textContent
      )
      this.inputSubsave = document.querySelector(
        '.p-sticky-menu .product-form input[name="selling_plan"]'
      )

      this.addEventListener('click', this.toggleDropdown)
      document.body.addEventListener(
        'click',
        this.closeDropdownFromOutside.bind(this)
      )

      this.listOfOptions.forEach((option) => {
        option.addEventListener('click', this.selectOption.bind(this))
      })
    }

    toggleDropdown(event) {
      event.stopPropagation()
      this.classList.toggle('opened')
    }

    selectOption(event) {
      this.listOfOptions.forEach((option) => {
        option.classList.remove('selected')
      })

      this.input.value = event.currentTarget.textContent
      this.productPrice.textContent = event.currentTarget.dataset.price

      if (this.inputSubsave !== undefined || this.inputSubsave !== null) {
        this.inputSubsave.value = event.currentTarget.dataset.select
      }

      event.currentTarget.classList.add('selected')
    }

    closeDropdownFromOutside() {
      if (this.classList.contains('opened')) {
        this.classList.remove('opened')
      }
    }
  }

  customElements.define('custom-select', CustomSelect)
})
